import { IconProps, iconA11yProps } from '../types';

export const Warning = ({ classNames, label }: IconProps) => (
    <svg className={classNames} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 34" {...iconA11yProps(label)}>
        <g>
            <path
                className="fill-warning"
                d="M18.28,3.25c.56-.95,1.79-1.26,2.74-.7,.29,.17,.53,.41,.7,.7l16.48,27.72c.56,.95,.25,2.18-.7,2.74-.31,.18-.66,.28-1.02,.28H3.52c-1.1,0-2-.9-2-2,0-.36,.1-.71,.28-1.02L18.28,3.25Z"
            />
            <path
                className="fill-white"
                d="M20.06,25.54c.48,0,.86,.14,1.15,.42s.43,.64,.43,1.07-.15,.78-.43,1.06-.67,.42-1.15,.42-.85-.14-1.14-.42-.43-.63-.43-1.06,.15-.79,.43-1.07,.67-.42,1.14-.42Zm1.17-1.54h-2.34l-.33-9.85h3.01l-.33,9.85Z"
            />
        </g>
    </svg>
);
